import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ForcePasswordChangeModal from '../ForcePasswordChangeModal';
import BlogHeader, { BlogPageVariant } from './BlogHeader';
import BlogFooter from './BlogFooter';
import { BlogSettingsProvider } from './blogSettings';
import { BLOG_PAGE_STYLE } from './BlogIcon';
import './blog.css';

/** چیدمان مستقل وبلاگ: هدر و فوتر اختصاصی طرح به‌جای هدر و فوتر سایت */
const BlogLayout: React.FC<{ variant: BlogPageVariant; children: React.ReactNode }> = ({ variant, children }) => {
  const { user } = useAuth();
  return (
    <BlogSettingsProvider>
      <div className="blog-page flex min-h-screen flex-col" dir="rtl" style={BLOG_PAGE_STYLE}>
        <BlogHeader variant={variant} />
        <main className="flex-1">{children}</main>
        <BlogFooter variant={variant} />
        <ForcePasswordChangeModal isOpen={user?.mustChangePassword === true} />
      </div>
    </BlogSettingsProvider>
  );
};

export default BlogLayout;
